import { render, staticRenderFns } from "./InventoryDashboard.vue?vue&type=template&id=e6b35280&"
import script from "./InventoryDashboard.vue?vue&type=script&lang=js&"
export * from "./InventoryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports